// Zustand
import { create } from 'zustand';
import { StateStorage, devtools, persist, createJSONStorage } from 'zustand/middleware';

// Slices import
import { AuthZustandSlice, createAuthZustandSlice } from './slices/AuthZustandSlice';
import { CurrentMagazineZustandSlice, createCurrentMagazineZustandSlice } from './slices/CurrentMagazineZustandSlice';
import { UserSettingsZustandSlice, createUserSettingsZustandSlice } from './slices/UserSettingsZustandSlice';
import { StoredMagazineZustandSlice, createStoredMagazineZustandSlice } from './slices/StoredMagazineZustandSlice';
import { ArticleModalZustandSlice, createArticleModalZustandSlice } from './slices/ArticleModalZustandSlice';
import { createOnboardingZustandSlice, OnboardingZustandSlice } from './slices/OnBoardingZustandSlice';
import { createSessionZustandSlice, SessionZustandSlice } from './slices/SessionZustandSlice';

// MMKV
import { MMKV } from 'react-native-mmkv';
import { Platform } from 'react-native';

export const storage = new MMKV({
    id: 'boyens-oneapp-app-storage',
});

export const secureStorage = new MMKV({
    id: 'boyens-oneapp-user-storage',
    ...(Platform.OS !== 'web' && { encryptionKey: 'yxi^sAdR9Cf#d9ShAI4tm*@2' }) // Apply encryption only for non-web platforms
});

// Zustand storages
const zustandStorage: StateStorage = {
    setItem: (name, value) => {
        return storage.set(name, value)
    },
    getItem: (name) => {
        const value = storage.getString(name)
        return value ?? null
    },
    removeItem: (name) => {
        return storage.delete(name)
    },
}

const zustandSecureStorage: StateStorage = {
    setItem: (name, value) => {
        return secureStorage.set(name, value)
    },
    getItem: (name) => {
        const value = secureStorage.getString(name)
        return value ?? null
    },
    removeItem: (name) => {
        return secureStorage.delete(name)
    },
}

// Log everytime state has changed
const log = (config: any) => (set: any, get: any, api: any) => config(
    (args: any) => {
        console.log('   applying', args)
        set(args)
        console.log('   new state', get())
    },
    get,
    api
);

// Non persistant storage
export const useBoundStore = create<
    ArticleModalZustandSlice &
    CurrentMagazineZustandSlice
>()(
    (...a) => ({
        ...createArticleModalZustandSlice(...a),
        ...createCurrentMagazineZustandSlice(...a),
    }),
);

// Persistant storage
export const usePersistBoundStore = create<
    UserSettingsZustandSlice &
    StoredMagazineZustandSlice &
    SessionZustandSlice &
    OnboardingZustandSlice
>()(

    persist(
        (...a) => ({
            ...createUserSettingsZustandSlice(...a),
            ...createStoredMagazineZustandSlice(...a),
            ...createSessionZustandSlice(...a),
            ...createOnboardingZustandSlice(...a),
        }),
        {
            name: 'bound-store',
            storage: createJSONStorage(() => zustandStorage),
            onRehydrateStorage: () => (state) => {
                state?.setHasHydrated(true);
            }
        })
);

// Persistant secure storage
export const usePersistSecureBoundStore = create<
    AuthZustandSlice
>()(
    devtools(
        persist(
            (...a) => ({
                ...createAuthZustandSlice(...a),
            }),
            {
                name: 'secure-bound-store',
                storage: createJSONStorage(() => zustandSecureStorage),
                onRehydrateStorage: () => (state) => {
                    state?.setHasHydrated(true);
                }
            }
        )
    )
);


